import React, { createContext, useContext, useMemo } from "react";
import { useUserNotificationTimezone } from "../hooks/useUserNotificationTimezone";
import { deviceIanaTimeZone } from "../utils/reportingTimeZone";

const fallbackZone = deviceIanaTimeZone();

const DisplayTimezoneContext = createContext<string>(fallbackZone);

/**
 * Resolves the IANA zone used to show trade times and dates across the app.
 * Mirrors GET /notifications/timezone (Display Preferences); falls back to device zone while loading.
 */
export function DisplayTimezoneProvider({ children }: { children: React.ReactNode }) {
  const { timezone } = useUserNotificationTimezone();
  const value = useMemo(
    () => timezone ?? fallbackZone,
    [timezone]
  );
  return (
    <DisplayTimezoneContext.Provider value={value}>
      {children}
    </DisplayTimezoneContext.Provider>
  );
}

export function useDisplayTimeZone(): string {
  return useContext(DisplayTimezoneContext);
}
